import React from 'react'
import {
  Input,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/react'
import { Field, FieldProps } from 'formik'

export interface FormInputProps {
  name: string
  label: string
  className?: string
  placeholder?: string
  isRequired?: boolean
}

export const FormInput: React.FC<FormInputProps> = ({
  name,
  label,
  className,
  placeholder = label,
  isRequired = false,
}) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        const handleChange: React.EventHandler<
          | React.FocusEvent<HTMLInputElement>
          | React.KeyboardEvent<HTMLInputElement>
        > = (event) => {
          const inputValue = (event.target as HTMLInputElement).value
          if (className === 'optionCsv' && inputValue.includes(',')) {
            if (
              event.type === 'blur' ||
              (event.type === 'keydown' &&
                (event as React.KeyboardEvent<HTMLInputElement>).key ===
                  'Enter')
            ) {
              form.setFieldValue(field.name, inputValue.replace(/,/g, '，'))
            }
          }
        }
        return (
          <FormControl
            name={name}
            isInvalid={!!(form.errors[name] && form.touched[name])}
            isRequired={isRequired}
            mb={3}
            onKeyDown={
              handleChange as React.KeyboardEventHandler<HTMLInputElement>
            }
            onBlur={handleChange as React.FocusEventHandler<HTMLInputElement>}
          >
            <FormLabel fontSize="xs" htmlFor={name}>
              {label}
            </FormLabel>
            <Input {...field} placeholder={placeholder} />
            <FormErrorMessage>{form.errors[name]}</FormErrorMessage>
          </FormControl>
        )
      }}
    </Field>
  )
}
